import Link from "next/link";
import ItemBuy from './account-buy';
import AccountEmpty from "./account-empty";
import {FiLogOut} from 'react-icons/fi';
import AccountForm from './account-form';

const Account = ({user, history, userDetail, setShowModal})=>{
    const Buys = ()=>{
      return history.map(i=>{ return <ItemBuy key={i.id_compra} data={i} setShowModal={setShowModal}/> })
    };
    const typeSection =  (history?.length) ? Buys() :  <AccountEmpty/>;

    return <div>
        <section className="account marginBottom">
            <div className="accountWrapper marginBottom-big">
                <div className="accountColumn">
                    <h1 className="title">Bienvenido {user.nombre}</h1>
                </div>
                <div className="accountColumn">
                    <div className="accountLogout">
                        <Link href="/cuenta/logout">
                            <a>
                                Cerrar sesión
                                <FiLogOut/>
                            </a>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="accountWrapper hidden-sm">
                <div className="accountColumn">
                    <h4 className="title-second marginBottom">Mis compras</h4>
                </div>
                <div className="accountColumn">
                    <h4 className="title-second marginBottom">Mi cuenta</h4>
                </div>
            </div>
            <div className="accountWrapper">
                <div className="accountColumn">
                    <div className="accountHistory">
                        {typeSection}
                    </div>
                </div>
                <div className="accountColumn">
                    <AccountForm userDetail={userDetail}/>
                </div>
            </div>
        </section>
    </div>
};

export default Account;
